import { DataStore } from '@getstep/sdk/dist/store/common/DataStore'
import { makeObservable, observable } from 'mobx'

export const searchParamCampaignKey = 'intent'

export class OnboardingStore extends DataStore {
    static readonly className = 'OnboardingStore'
    headerText = 'Exclusive Offer'
    isHeaderBackButtonVisible = false
    isHeaderActionButtonVisible = false
    isLoading = true

    constructor() {
        super()
        makeObservable(this, {
            headerText: observable,
            isHeaderBackButtonVisible: observable,
            isHeaderActionButtonVisible: observable,
            isLoading: observable,
        })
    }

    backButtonFn: () => Promise<void> = async () => {
        return
    }

    setHeaderText(newText: string) {
        this.headerText = newText
    }

    setHeaderBackButtonVisible(value: boolean) {
        this.isHeaderBackButtonVisible = value
    }

    setIsLoading(val: boolean) {
        this.isLoading = val
    }

    setBackButtonFn(fn: () => Promise<void>) {
        this.backButtonFn = fn
    }

    protected performLoad(): Promise<void> {
        return Promise.resolve()
    }
}
